export const CLEAR_BLUE = '#0366d6'
export const DARK_BLACK = '#000028'
export const GRAY = '#454545'
export const LIGHT_GRAY = '#dedede'
export const MINT_GREEN = '#82efb2'
export const TWITCH_PURPLE = '#6441a4'
